// globals: jQuery, Ajax, reportAjaxError, TakePayment

var cardConnectIframeAbstract;

(function($) {
    /**
     * @param config
     */

    var tokenized = false;
    var submitPartnerButtonClicked = false;
    cardConnectIframeAbstract = function(config) {
        this.config = {};
        if (config) {
            this.config = $.extend(this.config, config);
        }
    };

    /**
     * @param initConfig
     */
    cardConnectIframeAbstract.prototype.init = function(initConfig) {
        var self = this;
        if (initConfig) {
            this.config = $.extend(this.config, initConfig);
        }

        var buttonHtml = '';
        var iframeStyle = '';
        var errorMessage = '';
        if(this.config.iframeLocation === 'profile'){
            errorMessage = '<div class="cardConnectIframeError"></div>';
            buttonHtml += '<div id="cardConnectButtonContainer">' +
                '<button id="cardConnectContinueButton" type="button" class="cardConnectIframeButtons" style="display: none">Continue</button>' +
                '<button id="cardConnectVerifyButton" type="button" class="cardConnectIframeButtons">Verify <i class="fa fa-spinner fa-spin verify_loader" style="display: none"></i></button>' +
                '</div>';
            iframeStyle = 'style="width:100%;height:calc(100% - 160px)"';
        } else if (this.config.iframeLocation === 'pos') {
            buttonHtml += '<div style="clear:both"></div>';

            buttonHtml += '<button type="button" value="" id="cardConnectButtonPos" class="btn btn-primary ' +
                'btn-secure">' +
                'Secure My Payment Information <i class="fa fa-spinner fa-spin verify_loader" ' +
                'style="display: none"></i>' +
                '</button>';
            iframeStyle = 'style="width:100%;height:calc(100% - 34px);margin-top: -16px;"';
        } else if (this.config.iframeLocation === "partner") {
            buttonHtml += '<div style="clear:both"></div>';

            buttonHtml += '<button type="button" value="" id="cardConnectButtonPartner" class="btn btn-primary' +
                ' btn-secure" style="'+this.config.buttonStyle+'">Secure My Payment Information ' +
                '<i class="fa fa-spinner fa-spin verify_loader" style="display: none"></i></button>';
            iframeStyle = 'style="width:100%;height:110px;margin-top: -16px;"';
        }

        if (typeof(this.config.iframeStyle) !== "undefined") {
            iframeStyle = this.config.iframeStyle;
        }

        var queryString = self.createIframeUrl();

        var html = errorMessage;
        html += '<iframe id="tokenFrame" name="tokenFrame" src="'+queryString+'" frameborder="0" scrolling="no" '+iframeStyle+'></iframe>';
        html += buttonHtml;
        html += '<input type="hidden" value="" name="mytoken" id="mytoken" />';
        html += '<input type="hidden" value="" name="myexpiry" id="myexpiry" />';

        $('#'+this.config.frameContainer).html(html);

        $('#cardConnectVerifyButton').off('click').on('click', function(){
            self.verifyEvent();
        });

        $('#cardConnectContinueButton').off('click').on('click', function(){
            self.continueEvent();
        });

        $('#cardConnectButtonPos').off('click').on('click', function(){
            self.submitPosButton();
        });

        $('#cardConnectButtonPartner').off('click').on('click', function(){
            submitPartnerButtonClicked = true;
            self.submitPartnerButton();
        });

        if (this.config.isEmvTerminal) {
            var $useEmvTerminalBtn = $(this.config.formSelector)
                .find('#useEmvTerminalBtn');
            $useEmvTerminalBtn.removeClass('hidden');
            $useEmvTerminalBtn.on('click', function() {
                self.openEmvTerminal();
            });
        }

        window.addEventListener('message', function(event) {
            var token = {};
            if (event.data) {
                try {
                    token = (typeof event.data === 'object') ? event.data :
                        (typeof event.data === 'string') ? JSON.parse(event.data) : {};
                } catch (e) {
                    token = {};
                }
            }
            var mytoken = document.getElementById('mytoken');
            var myexpiry = document.getElementById('myexpiry');
            if (typeof(token.message) !== 'undefined' && typeof(token.expiry) !== 'undefined') {
                mytoken.value = token.message;
                myexpiry.value = token.expiry;
                if (myexpiry.value.length && myexpiry.value.length === 4) {
                    const yymmRegex = new RegExp('(1[2-9]|[2-9][0-9])(0[1-9]|1[0-2])', 'g');
                    if (yymmRegex.test(myexpiry.value) === true) {
                        myexpiry.value = '20' + myexpiry.value;
                    }
                }

                $('#cardConnectIframeError').html('');
                $('#cardConnectContinueButton').hide();
                $('#cardConnectVerifyButton').show();
                $('#cardConnectButtonPos').val('Secure My Payment Information');
                if (token.errorCode === '0') {
                    tokenized = true;
                    if (submitPartnerButtonClicked) {
                        submitPartnerButtonClicked = false;
                        self.submitPartnerButton();
                    }
                    $('.cardConnectIframeError').html('');
                    $('#cardConnectVerifyButton').hide();
                    $('#cardConnectContinueButton').show();
                } else {
                    tokenized = false;
                }
            }
        }, false);
    };

    cardConnectIframeAbstract.prototype.onEmvSuccess = function() {
    };

    cardConnectIframeAbstract.prototype.openEmvTerminal = function () {
        var self = this;
        TakePayment.callTerminal(
            {},
            function(data) {
                var $dialogContent = jQuery('<div>' +
                    '<p class="pos-terminal-text">Please process payment through the EMV terminal.</p>' +
                    '</div>');

                var url = '/payment/emv-terminal-create-token';

                new Ajax.Request(
                    url,
                    {
                        method: 'post',
                        parameters: data,
                        onComplete: function (request) {
                            $dialogContent.caDialog('close');
                            var responseJSON = request.responseJSON;
                            if (request.status === 0) {
                                return false;
                            }
                            if (responseJSON.status === 1) {
                                self.onEmvSuccess(responseJSON.token);
                            }
                        },
                        onFailure: reportAjaxError
                    }
                );
                $dialogContent.caDialog({
                    title: 'Transaction In Progress...',
                    resizable: false,
                    width: 600,
                    showCloseButton: false,
                    modal: true
                });
            }
        );
    };

    /**
     * @returns {string}
     */
    cardConnectIframeAbstract.prototype.createIframeUrl = function (){
        var config = this.config;
        var cardConnectSite = jQuery('#gatewaySite').val();
        if (typeof(this.config.gatewaySite) !== "undefined") {
            cardConnectSite = this.config.gatewaySite;
        }
        var queryString = 'https://'+cardConnectSite+'.cardconnect.com/itoke/ajax-tokenizer.html?';

        if(config.cssRules.length) {
            queryString += 'css=' + config.cssRules.join('');
        }

        $.each(config.frameOptions, function (index, value) {
            queryString +=  '&'+index+'='+value;
        });

        return encodeURI(queryString);
    };

    /**
     * @param validationError
     */
    cardConnectIframeAbstract.prototype.displayErrorMessage = function (validationError) {
        if(validationError !== undefined){
            $('.cardConnectIframeError').css('display','block').html('Error: ' + validationError);

            setTimeout(function() {
                $('.cardConnectIframeError').html('');
            }, 2000);
        }
    };

    cardConnectIframeAbstract.prototype.onSuccess = function() {
    };

    /**
     * @param $form
     * @param data
     * @param callback
     */
    cardConnectIframeAbstract.prototype.setCardConnectParamsToForm = function($form, data, callback) {

        data.expiration_year = data.cardConnect_expiry.slice(0,4);
        var expiration_month = data.cardConnect_expiry.slice(4);

        if(expiration_month.length === 1){
            expiration_month = '0' + expiration_month;
        }
        data.expiration_month = expiration_month;
        data.expiration_date = data.expiration_year + '-' + data.expiration_month + '-01';
        /*
        * Payment card tokens are generally 16-digit numeric tokens with the following characteristics:
            -> The token begins with a 9.
            -> The second and third digits of a token represent the first and second digits of the card.
            -> The last 4 digits of the token represent the last 4 digits of the card.
        */
        var ccNumberEscape = data.cc_merchant_unique_id.slice(1, 2) + Array(12).join('*') + data.cc_merchant_unique_id.slice(12, 16);
        data.cc_number = ccNumberEscape;

        $form.find('[name=cc_merchant_unique_id]').val(data.cc_merchant_unique_id);
        $form.find('[name=cc_date]').val(data.expiration_date);
        $form.find('[name=cc_number],[name="ccInfo[ccNumber]"],[name=card_number]').val(data.cc_number);
        $form.find('#cc_date-month').val(data.expiration_month);
        $form.find('#cc_date-year').val(data.expiration_year);
        callback();
    };

    /**
     * @returns {boolean}
     */
    cardConnectIframeAbstract.prototype.verifyEvent = function () {
        var self = this;
        $('.verify_loader').show();
        $('.cardConnectIframeError').html('');
        //perform the onBlur event on the iframe...
        $('body').click();
        //settimeout to make sure that event will always be executed before this verify event
        setTimeout(function () {
            var token = $('#mytoken').val();
            var exp = $('#myexpiry').val();

            if(tokenized === false && (token === '' || exp === '' )){
                self.displayErrorMessage('Please provide correct credit card details.');
            }
            $('.verify_loader').hide();
        }, 1000);
    };

    cardConnectIframeAbstract.prototype.continueEvent = function () {
        var self = this;
        var token = $('#mytoken').val();
        var exp = $('#myexpiry').val();
        if (tokenized === true && token !== '') {
            $('.cardConnectIframeError').html('');
            var data = {cc_merchant_unique_id: token, cardConnect_expiry: exp};
            var $form = self.config.cardConnectParamsToFormSelector ? $(self.config.cardConnectParamsToFormSelector) : $(form);
            self.setCardConnectParamsToForm($form, data, function () {
                self.onSuccess($form, data);
            });
            tokenized = false;
        }
    };

    cardConnectIframeAbstract.prototype.submitPartnerButton = function () {
        var self = this;
        $('#cardConnectButtonPartner').prop('disabled', true);
        $('.verify_loader').show();
        $('.cardConnectIframeError').html('');
        setTimeout(function () {
            var token = $('#mytoken').val();
            var exp = $('#myexpiry').val();

            if (tokenized === false && (token === '' || exp === '')) {
                self.displayErrorMessage('Please provide correct credit card details.');
                $('.verify_loader').hide();
                $('#cardConnectButtonPartner').prop('disabled', false);
                submitPartnerButtonClicked = false;
                return false;
            } else if (tokenized === true && token !== '') {
                var data = {cc_merchant_unique_id: token, cardConnect_expiry: exp};
                var $form = self.config.cardConnectParamsToFormSelector ?
                    $(self.config.cardConnectParamsToFormSelector) : $(form);
                self.setCardConnectParamsToForm($form, data, function () {
                    self.onSuccess($form, data);
                });
                tokenized = false;
            }
        }, 2000);
    };

    /**
     * @returns {boolean}
     */
    cardConnectIframeAbstract.prototype.submitPosButton = function () {
        var self = this;
        $('#cardConnectButtonPos').prop('disabled',true);
        $('.verify_loader').show();
        $('.cardConnectIframeError').html('');
        setTimeout(function () {
            var token = $('#mytoken').val();
            var exp = $('#myexpiry').val();

            if(tokenized === false && (token === '' || exp === '')) {
                self.displayErrorMessage('Please provide correct credit card details.');
                $('.verify_loader').hide();
                $('#cardConnectButtonPos').prop('disabled',false);
                return false;
            }else if(tokenized === true && token !== '') {
                $('#cc_merchant_unique_id').val(token);
                $('#cc_date').val(exp);
                var ccNumberEscape = token.slice(1, 2) + Array(12).join('*') + token.slice(12, 16);
                $('#ccInfo-ccNumber').val(ccNumberEscape);
                var url = '/payment/take-payment?&ajax=true';
                if (window.location.href.includes('noframe=1')) {
                    url += '&noframe=1';
                }
                showAjaxStarted();
                new Ajax.Request(
                    url,
                    {
                        method: 'post',
                        parameters: $('#takePaymentForm, #pos_form').serialize(),
                        onComplete: function(response) {
                            $('#take_payment').html(response.responseText);
                            showAjaxFinished();
                        },
                        onFailure: function() {
                            alert('fail');
                            showAjaxFinished();
                        }
                    }
                );
            }
        }, 1000);
    };

})(jQuery);

export default cardConnectIframeAbstract;
